export enum VirtualForumCode {
  VirtualVenueCode = "VIRTV",
  VirtualBuildingCode = "VIRTB",
  VirtualFacilityCode = "VIRTF",
}
